import React from 'react';
import { Table } from 'antd';
import moment from 'moment-timezone';
import styled from 'styled-components';

import { prepareTableData, getPercentage } from '../../utils/retention';

const { Column, ColumnGroup } = Table;

const StyledFooter = styled.tfoot`
  background-color: #fafafa;

  .border {
    border-left: 1px solid #e8e8e8;
  }

  td {
    border-right: 1px solid #e8e8e8;
    border-bottom: 1px solid #e8e8e8;
  }
`;

// нужен для того чтобы в футере был summary.
// TODO обновить до antD 4, в таблицу будет встроен summary.
const TableComponent =
  (averageData, cellWidth) =>
  ({ className, style, children }) =>
    (
      <table className={className} style={style}>
        {children}
        <StyledFooter>
          <tr className="ant-table-row ant-table-row-level-0">
            <td className="st-table-cell middle border">
              <h4 style={{ wordBreak: 'normal' }}>Total</h4>
            </td>
            {averageData.map((d, i) => (
              <td
                // eslint-disable-next-line react/no-array-index-key
                key={i}
                className={i === 0 ? 'st-table-cell middle' : 'st-table-cell'}
                style={i ? { width: `${cellWidth}%` } : null}
              >
                {i ? `${d.percent}% (${d.value})` : d.value}
              </td>
            ))}
          </tr>
        </StyledFooter>
      </table>
    );

const RetentionTableResult = ({ result, dimensionType, timezone, sequence }) => {
  let layout;

  if (result) {
    const { dataSource, firstColumnTitle, sequenceColumnGroupTitle, averageData } =
      prepareTableData(result, dimensionType);

    const cellWidth = 84 / averageData.length;

    const filteredDataSource = dataSource.filter((u) => !!u[0]);

    layout = (
      <Table
        dataSource={filteredDataSource}
        bordered
        size="middle"
        pagination={{ showSizeChanger: true, position: 'top' }}
        components={{ table: TableComponent(averageData, cellWidth) }}
        style={{ width: '100%' }}
      >
        <Column
          title={<h4 style={{ wordBreak: 'normal' }}>{firstColumnTitle}</h4>}
          key="date"
          className="st-table-cell middle"
          render={(text, record) => (
            <span>{moment.tz(record.date, timezone).format('YYYY-MM-DD')}</span>
          )}
        />
        <Column title={<h4>Users</h4>} className="st-table-cell middle" dataIndex="0" key="0" />
        <ColumnGroup title={<h4>{sequenceColumnGroupTitle}</h4>}>
          {sequence.map((seqNum, i) => (
            <Column
              title={<h4>{`+${seqNum}`}</h4>}
              key={seqNum}
              width={`${cellWidth}%`}
              className="st-table-cell"
              render={(text, record) => (
                <span>
                  {record[i + 1]
                    ? `${getPercentage(record[0], record[i + 1])}% (${record[i + 1]})`
                    : ''}
                </span>
              )}
            />
          ))}
        </ColumnGroup>
      </Table>
    );
  } else {
    layout = <span />;
  }

  return layout;
};

export default RetentionTableResult;
